import { ABOUT_BG } from "@/lib/site";
import { Check } from "lucide-react";

const POINTS = [
  "Owner-led project management on every job",
  "Self-performed framing, drywall, paint, flooring, finish",
  "Licensed, bonded and insured in Utah",
  "Clean job sites and clear daily communication",
  "Dedicated maintenance department for ongoing work",
  "Residential remodeling and full ground-up new construction",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-navy text-white py-20 md:py-32 overflow-hidden">
      <div className="px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 relative">
            <div className="aspect-[4/3] sm:aspect-[4/5] relative overflow-hidden rounded-2xl elev-3">
              <img src={ABOUT_BG} alt="Utah mountain range" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-4 right-4 lg:right-auto lg:-right-6 lg:-bottom-6 bg-sunrise text-white p-5 lg:p-8 max-w-[240px] lg:max-w-[280px] rounded-2xl elev-3">
              <div className="num-label text-4xl lg:text-5xl leading-none">5</div>
              <div className="text-xs uppercase tracking-[0.25em] mt-2 opacity-90">
                Peaks. One promise — built right.
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.25em] sm:tracking-[0.3em] text-sunrise">— Who we are</div>
            <h2 className="mt-4 font-display font-black tracking-tight text-[32px] sm:text-5xl lg:text-6xl leading-[1.04]">
              A Utah crew that <br />
              <span className="text-sunrise">treats your build like ours.</span>
            </h2>
            <p className="mt-6 text-white/75 text-base lg:text-lg leading-relaxed">
              Five Peaks Construction LLC was founded on a simple idea: when a single team can frame the walls, hang the
              drywall, install the flooring and roll the final coat of paint — your project gets done faster and finished
              better. We work across residential and commercial in Utah, from quick remodels to full ground-up builds.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-white/85">
                  <span className="mt-1 w-5 h-5 grid place-items-center bg-sunrise rounded-md shrink-0">
                    <Check className="w-3 h-3" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
